module.exports = __webpack_public_path__ + "media/assets/images/payment/amex-71f3d9f12710f79052c42736b4f0a996.png";